export { default } from './SectionCompanies';